import { FC } from 'react';
import { Stack } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

interface PageTitleProps {
  title: string;
  count?: number;
  description: string;
}

const PageTitle: FC<PageTitleProps> = ({ count, description, title }) => (
  <>
    <Stack direction="row" paddingBottom="space-8" spacing="space-4">
      <Heading size="lg">{title}</Heading>

      {count ? (
        <Heading color="text-discreet" size="lg">
          ({count})
        </Heading>
      ) : null}
    </Stack>

    <Text marginBottom="space-32" size="lg">
      {description}
    </Text>
  </>
);

export default PageTitle;
